import ErrorComponent from '@mui/icons-material/Error';
import Warning from '@mui/icons-material/Warning';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { AlertTooltip } from '@openx/components-core/lib/AlertTooltip/AlertTooltip.tsx';
import { HighlightedPhrase } from '@openx/components-core/lib/HighlightedPhrase/HighlightedPhrase.tsx';
import { segmentExpiredText, segmentSoonWillBeExpired, segmentStatus } from '@openx/types/segments.ts';
import { isSoonToDate } from '@openx/utils/lib/date.ts';

type Props = {
  estimatedExpiryDate?: string | null;
  name: string | number;
  status?: string | null;
  searchPhrase: string;
};

export const NameCell = ({ name, estimatedExpiryDate, status, searchPhrase }: Props) => {
  const showExpiredAlert = status === segmentStatus.EXPIRED;
  const showExpireSoonAlert = isSoonToDate(estimatedExpiryDate);

  const expiredText = segmentExpiredText(false);
  const soonWillBeExpiredText = segmentSoonWillBeExpired(false);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        maxWidth: 274,
        paddingTop: 0.5,
        paddingBottom: 0.5,
      }}
    >
      <Typography
        variant="body1Bold"
        data-test="row-title"
        sx={{
          mr: 0.625,
          lineHeight: '22px',
          color: 'primary.main',
        }}
      >
        <HighlightedPhrase searchPhrase={searchPhrase}>{name.toString()}</HighlightedPhrase>

        {showExpiredAlert && (
          <AlertTooltip
            color={theme => theme.palette.error.main}
            title={expiredText}
            icon={<ErrorComponent fontSize="small" color="inherit" />}
            sx={{ mt: -0.5, padding: 0 }}
          />
        )}

        {showExpireSoonAlert && (
          <AlertTooltip
            color={theme => theme.palette.warning.main}
            title={soonWillBeExpiredText}
            icon={<Warning fontSize="small" color="inherit" />}
            sx={{ mt: -0.5, padding: 0 }}
          />
        )}
      </Typography>
    </Box>
  );
};
